// extracted by mini-css-extract-plugin
module.exports = {"form":"form--g2jCQ"};